export const COOKIE_KEY_LOCAL_STORAGE = "COOKIE_KEY_LOCAL_STORAGE";
